// material-ui
import { Typography } from '@mui/material';

// project imports
import { useArchitectureMenu, useFundsMenu } from 'hooks/useFundsMenu';
import accountingDashboard from 'menu-items/accounting-menu-items/dashboard';
import architectDashboard from 'menu-items/architecture-menu-items/dashboard';
import dashboard from 'menu-items/dashboard';
import procurementDashboardMenu from 'menu-items/procument-menu-items/dashboard';
import qsDashboardMenu from 'menu-items/qs-menu-items/dashboard';
import roadsMenuItems from 'menu-items/roads-menu-items';
import { useLocation } from 'react-router-dom';
import { formatFundsMenu } from 'utils/formartFundsMenu';
import { sectorFundsMenu } from 'utils/sectorFormatter';
import NavGroup from './NavGroup';
import { useFilteredMenuItems } from './UseFilteredMenuItems';

// ==============================|| SIDEBAR MENU LIST ||============================== //
export const MainMenuItems = () => {
    const { fundsMenu, isLoading } = useFundsMenu();

    return {
        items: [
            dashboard,
            ...(isLoading ? [] : formatFundsMenu(fundsMenu))
        ]
    }

}
export const QsMenuItems = () => {
    const { fundsMenu, isLoading } = useFundsMenu();

    return {
        items: [
            qsDashboardMenu,
            ...(isLoading ? [] : sectorFundsMenu(fundsMenu,'qs'))
        ]
    }

}
export const ProcuremetMenuItems = () => {
    const { fundsMenu, isLoading } = useFundsMenu();

    return {
        items: [
            procurementDashboardMenu,
            ...(isLoading ? [] : sectorFundsMenu(fundsMenu,'procurement'))
        ]
    }

}
export const AccountingMenuItems = () => {
    const { fundsMenu, isLoading } = useFundsMenu();

    return {
        items: [
            accountingDashboard,
            ...(isLoading ? [] : sectorFundsMenu(fundsMenu,'accounting'))
        ]
    }

}
export const ArchitectMenuItems = () => {
    const { architectMenu, isLoading } = useArchitectureMenu();

    return {
        items: [
            architectDashboard,
            ...(isLoading ? [] : architectMenu)
        ]
    }

}

const MenuList = () => {
    const location = useLocation();
    const firstPart = location.pathname.split('/')[1];

    let rawNavItems = [];
    if (firstPart === 'civils') {
        rawNavItems = roadsMenuItems;
    } else if (firstPart === 'accounting') {
        rawNavItems = AccountingMenuItems();
    } else if (firstPart === 'procurement') {
        rawNavItems = ProcuremetMenuItems();
    } else if (firstPart === 'qs') {
        rawNavItems = QsMenuItems();
    } else if (firstPart === 'architecture') {
        rawNavItems = ArchitectMenuItems()
    } else {
        rawNavItems = MainMenuItems();
    }

    const navItems = useFilteredMenuItems(rawNavItems);

    return navItems.items.map((item) => {
        switch (item.type) {
            case 'group':
                return <NavGroup key={item.id} item={item} />;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });
};

export default MenuList;
